export { default as Tabs } from './Tabs/Tabs'
